/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Many_Drab_Hawk_EmpowerInputs */

const fr_many_drab_hawk_empower = /** @type {(inputs: Many_Drab_Hawk_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package`)
};

/**

* @param {Many_Drab_Hawk_EmpowerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const many_drab_hawk_empower = /** @type {((inputs?: Many_Drab_Hawk_EmpowerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Many_Drab_Hawk_EmpowerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_many_drab_hawk_empower(inputs)
});